export const CART_STORAGE_KEY = 'kilimmanjaro_cart';
export const GUEST_CART_MERGED_PREFIX = 'kilimmanjaro_guest_cart_merged_';

/** Vide le panier local (localStorage) et les flags de fusion invité. */
export function clearLocalCartStorage() {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(CART_STORAGE_KEY, JSON.stringify([]));
  } catch {
    // Ignorer (quota, mode privé, etc.)
  }
  try {
    const keysToRemove = [];
    for (let i = 0; i < sessionStorage.length; i += 1) {
      const key = sessionStorage.key(i);
      if (key?.startsWith(GUEST_CART_MERGED_PREFIX)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => sessionStorage.removeItem(key));
  } catch {
    // Ignorer
  }
}
